import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { FormatVO } from '@wizeoo/akm-common-lib';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
/**
 * renderer d'une colonne avec icone close pour le ag-grid
 */
@Component({
  selector: 'format-lock-renderer',
  template: `<wiz-hgroup height="100%" width="100%" verticalAlign="center" horizontalAlign="center">
    <wiz-icon *ngIf="basicFormat" height="16px">cancel</wiz-icon>
  </wiz-hgroup>`,
  styles: [':host {height:100%; width: 100%; max-width: 100%}'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormatLockRenderer implements AgRendererComponent {
  data: FormatVO;
  public basicFormat: boolean = false;

  constructor(private cdref: ChangeDetectorRef) {}

  public refresh(params: ICellRendererParams): boolean {
    this.data = params.data;
    this.basicFormat = this.data.basicFormat;
    this.cdref.markForCheck();
    return true;
  }

  public agInit(params: ICellRendererParams) {
    this.data = params.data;
    this.basicFormat = this.data.basicFormat;
    this.cdref.markForCheck();
  }
}
